import React from "react"
import { createRoot } from "react-dom/client"

import { registry } from "./registry"

function parseProps(raw) {
  if (!raw) return {}

  try {
    return JSON.parse(raw)
  } catch {
    return {}
  }
}

export function mountReactComponents() {
  document.querySelectorAll("[data-react-component]").forEach((node) => {
    const componentName = node.dataset.reactComponent
    const Component = registry[componentName]
    if (!Component) return

    const props = parseProps(node.dataset.props)

    if (!node.__reactRoot) {
      node.__reactRoot = createRoot(node)
    }

    node.__reactRoot.render(React.createElement(Component, props))
  })
}

export function unmountReactComponents() {
  document.querySelectorAll("[data-react-component]").forEach((node) => {
    if (!node.__reactRoot) return
    node.__reactRoot.unmount()
    delete node.__reactRoot
  })
}
